export const selectProfile = state => {
  return state.profile.profile;
};
export const selectIsFetchingProfile = state => {
  return state.profile.isFetchingProfile;
};
export const selectIsFollowingProfile = state => {
  return state.profile.isFollowing;
};
export const selectProfileLastActive = state => {
  return state.profile.lastActive;
};
